import React from 'react';

const renderTableHeader = (headers) => {
  let header = Object.keys(headers);
  return header.map((heading, index) => {
    let columnHeading = ( ({
      'id': 'Retailer ID',
      'name': 'Retailer Name',
      'rechargeAmount': 'RC Value'
    })[heading])
    return <th key={index}>{columnHeading}</th>
  })
}

const renderTableBody = (tableBody) => {
  return tableBody.map((row, index) => {
    const { id, name, rechargeAmount } = row;
    return (
      <tr key={index}>
        <td>{id}</td>
        <td>{name}</td>
        <td>{rechargeAmount}</td>
      </tr>
    )
  })
}

export default function RechargeSalesOthersCustomizedTables(props) {
  const { data  } = props;
  const tableData = Object.values(data);

  return (
    tableData && tableData.length ? 
    (
      <div className="datatable">
        <table className="table table-striped">
          <thead>
              <tr>
              { renderTableHeader(tableData[0]) }
              </tr>
          </thead>
          <tbody>
            { renderTableBody(tableData) }
          </tbody>
        </table>
      </div>
    )
    :
    'NO DATA AVAILABLE'
  );
}